import React, { FC, useEffect } from 'react';

import { Modal } from '@opendoor/bricks/complex';
import { Box, Button, Flex } from '@opendoor/bricks/core';
import { useObservability } from 'shared/helpers/observability';

import {
  ContactOnMistake,
  getShouldShowBottomContactInfo,
  Reason,
  REFRESH_ERROR_REASON_TITLE,
} from 'shared/routes/errors/RefreshErrorPage';
import { OdProtosCommonSell_SellDirectOfferRefreshStatus as Status } from '__generated__/globalTypes';

interface IRefreshErrorModal {
  /** Function to close the modal */
  closeModal: () => void;
  /** Whether the modal is open */
  isOpen: boolean;
  /** The refresh status */
  refreshStatus: Status | undefined | null;
}

/** Modal that shows refresh offer errors */
export const RefreshErrorModal: FC<IRefreshErrorModal> = ({
  closeModal,
  isOpen,
  refreshStatus,
}) => {
  const { trackEvent } = useObservability();
  useEffect(() => {
    // only track the page-view event when the modal opens
    isOpen &&
      trackEvent(
        'view',
        'refresh-error-modal',
        { error: refreshStatus },
        { categoryOverride: 'page' },
      );
  }, [isOpen, refreshStatus, trackEvent]);

  const shouldShowBottomContactInfo = getShouldShowBottomContactInfo(refreshStatus);

  return (
    <Modal
      analyticsName="cake-refresh-error-modal"
      isOpen={isOpen}
      showClose
      onRequestClose={closeModal}
      aria-labelledby={REFRESH_ERROR_REASON_TITLE}
    >
      <Flex flexDirection="column" justifyContent="space-between" height={['100%', null, 'auto']}>
        <Box>
          <Reason refreshStatus={refreshStatus} />
          {shouldShowBottomContactInfo && (
            <Box mt={[11, null, 9]}>
              <ContactOnMistake />
            </Box>
          )}
        </Box>
        <Button
          aria-label="Go back and close modal"
          mt={[0, null, 11]}
          analyticsName="close-refresh-error-modal"
          onClick={closeModal}
          variant="secondary"
        >
          Go back
        </Button>
      </Flex>
    </Modal>
  );
};
